import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

export const categoriesContainerStyle = css`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: ${theme.spacing(2)};
`;

export const actionsContainerStyle = css`
  display: flex;
  justify-content: space-between;
  gap: ${theme.spacing(2)};
  margin-top: ${theme.spacing(2)};
`;
